import React from 'react'

import classnames from 'classnames'
import { useField, useFormikContext } from 'formik'
import moment, { isMoment } from 'moment'

import DatePicker, { DatePickerProps } from '../components/DatePicker'
import Label from '../components/Label'
import RedAsterisk from '../components/RedAsterisk'
import FieldProps from './FieldProps'
import Error from './FormItemError'

type Props = DatePickerProps &
  FieldProps & {
    noStyles?: boolean
    hideError?: boolean
    showRequiredSign?: boolean
    labelBlock?: boolean
    helperText?: string
    optional?: boolean
    popupClassName?: string
    labelStyle?: string
    divClassName?: string
  }

const FormikDatePickerField: React.FC<Props | any> = (props) => {
  const [field, meta] = useField(props)

  const context = useFormikContext()
  const showError = meta.touched && meta.error
  const error = showError ? <Error>{meta.error}</Error> : null

  const onDateChange = (date: moment.Moment | null, dateString: string) => {
    const value = dateString ? moment.utc(dateString).format('YYYY-MM-DD') : null
    context.setFieldValue(props.name, value)
    if (props.onChange) {
      props.onChange(value)
    }
  }

  const datePickerClassname = classnames({
    'formik-datepicker': !props.noStyles,
  })

  const labelClassname = classnames({
    'no-select flex': true,
    'formik-field__input-label': !props.noStyles,
  })

  return (
    <div className={`mb-8 ${props.divClassName}`}>
      <div>
        {props.label && (
          <Label htmlFor={props.id || props.name} className={`${labelClassname} ${props.labelStyle}`}>
            {props.showRequiredSign && <RedAsterisk className={'mr-4'} />}
            {props.label}
            {props.optional && <span className={'field-optional ml-4'}> (optional)</span>}
          </Label>
        )}
        <DatePicker
          defaultValue={field.value ? (isMoment(field.value) ? field.value : moment(field.value)) : null}
          {...props}
          onChange={onDateChange}
          className={`${datePickerClassname} ${props.className} ${props.labelBlock ? 'w-100' : ''}`}
          format={props.format ?? 'MM/DD/YYYY'}
        />
      </div>
      {!props.hideError && error}
      {props.helperText && <span className={'h6 mt-4 color-gray-7'}>{props.helperText}</span>}
    </div>
  )
}
export { FormikDatePickerField as DatePicker }
export default FormikDatePickerField
